__turbopack_context__.v({
  "circle": "circledicon-module__YJlerW__circle",
});
